import { getMonth, isAfter, isBefore, isSameYear } from 'date-fns'

import { YEAR_FIRST_MONTH, YEAR_LAST_MONTH } from '../../../constants/date'

/**
 * @param {Date} value
 * @param {Date?} maxValue
 */
export function getMaxMonth(value, maxValue) {
  return maxValue == null
    ? YEAR_LAST_MONTH
    : isSameYear(value, maxValue)
      ? getMonth(maxValue)
      : isBefore(value, maxValue)
        ? YEAR_LAST_MONTH
        : YEAR_FIRST_MONTH - 1
}

/**
 * @param {Date} value
 * @param {Date?} minValue
 */
export function getMinMonth(value, minValue) {
  return minValue == null
    ? YEAR_FIRST_MONTH
    : isSameYear(value, minValue)
      ? getMonth(minValue)
      : isAfter(value, minValue)
        ? YEAR_FIRST_MONTH
        : YEAR_LAST_MONTH + 1
}
